import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// 全域
import modalStatus from './modules/global/modalStatus';
import alarmStatus from './modules/global/alarmStatus';
import globalList from './modules/global/globalList';
import accountType from './modules/global/accountType';
import log from './modules/global/log';
// mb
import mbEnterpriseGlobal from './modules/mb/enterprise/global.js';
import mbEnterpriseAlarmStatus from './modules/mb/enterprise/alarmStatus.js';
import mbEnterpriseMeterRecord from './modules/mb/enterprise/meterRecord.js';

// 個人房東
import user from './modules/landlord/user';
import houseStatus from './modules/landlord/houseStatus';
import recommandTenant from './modules/landlord/recommandTenant.js';
import bookingManagement from './modules/landlord/bookingManagement';
import houseManagement from './modules/landlord/houseManagement';
import leaseManagement from './modules/landlord/leaseManagement';
import evaluation from './modules/landlord/evaluation';
import addHouse from './modules/landlord/addHouse';
import editHouse from './modules/landlord/editHouse';
import newContract from './modules/landlord/newContract';
import loadingAnimation from './modules/landlord/loadingAnimation';
import device from './modules/landlord/device';
import batchUpload from './modules/landlord/batchUpload';
import memberCenter from './modules/landlord/memberCenter';
import userVerified from './modules/landlord/userVerified';
import financialManagement from './modules/landlord/financialManagement';
import financialAccountingBook from './modules/landlord/financialAccountingBook';
import financialBill from './modules/landlord/financialBill';
import leaseDone from './modules/landlord/leaseDone';
import userWallet from './modules/landlord/userWallet';
import shareHouse from './modules/landlord/shareHouse';



//企業
import bizUser from './modules/bussiness/bizUser';
// 個人中心
import bizPersonalCenter from './modules/bussiness/personalCenter/personalCenter.js';
// 個人首頁
import bizTodoListGraph from './modules/bussiness/personalHome/todoListGraph.js';
import bizTodoList from './modules/bussiness/personalHome/todoList.js';
import bizRecommandTenant from './modules/bussiness/personalHome/recommandTenant.js';
// 房源管理
import bizHouseManagement from './modules/bussiness/mgtCategory/houseMgt/houseManagement';
import bizAddHouse from './modules/bussiness/mgtCategory/houseMgt/addHouse';
import bizEditHouse from './modules/bussiness/mgtCategory/houseMgt/editHouse';
import bizBatchUpload from './modules/bussiness/mgtCategory/houseMgt/batchUpload';
import bizBatchPolicy from './modules/bussiness/mgtCategory/houseMgt/batchPolicy';
import bizBatchPublish from './modules/bussiness/mgtCategory/houseMgt/batchPublish';
import bizBatchDispatch from './modules/bussiness/mgtCategory/houseMgt/batchDispatch';
import bizBatchContractVersion from './modules/bussiness/mgtCategory/houseMgt/batchContractVersion';
// 快速鍵群
import bizHouseGroupManagement from './modules/bussiness/mgtCategory/houseGroupMgt/houseGroupMgt';
import bizEditHouseGroup from './modules/bussiness/mgtCategory/houseGroupMgt/editHouseGroup';
// 預定管理
import bizBookingMgt from './modules/bussiness/mgtCategory/bookingMgt/bookingMgt';
// 任務管理
import bizTaskDoneMgt from './modules/bussiness/mgtCategory/taskMgt/taskDoneMgt';
import bizTaskUnpaidMgt from './modules/bussiness/mgtCategory/taskMgt/taskUnpaidMgt';
import bizTaskProcessMgt from './modules/bussiness/mgtCategory/taskMgt/taskProcessMgt';
// 租約管理
import bizLeaseMgtProcess from './modules/bussiness/mgtCategory/leaseMgt/leaseProcess';
import bizLeaseMgtBeSigned from './modules/bussiness/mgtCategory/leaseMgt/leaseBeSigned';
import bizLeaseMgtFinished from './modules/bussiness/mgtCategory/leaseMgt/leaseFinished';
import bizMeterRecord from './modules/bussiness/mgtCategory/leaseMgt/meterRecord';
import bizSignContract from './modules/bussiness/mgtCategory/leaseMgt/bizSignContract';
import bizNewContract from './modules/bussiness/mgtCategory/leaseMgt/newContract';
import bizNewEContract from './modules/bussiness/mgtCategory/leaseMgt/newEContract';
import bizRenewalContract from './modules/bussiness/mgtCategory/leaseMgt/renewalContract.js';
import bizBatchNotify from './modules/bussiness/mgtCategory/leaseMgt/batchNotify';
import bizBatchMeterNotify from './modules/bussiness/mgtCategory/leaseMgt/batchMeterNotify';
import bizBatchBill from './modules/bussiness/mgtCategory/leaseMgt/batchBill.js';
// 房東管理
import bizlandlordMgt from './modules/bussiness/mgtCategory/landlordMgt/landlordMgt';

// 收支報表
import bizBillManagement from './modules/bussiness/financialReport/billMgt';
import bizLedgerManagement from './modules/bussiness/financialReport/ledgerMgt';
import bizLandlordReport from './modules/bussiness/financialReport/landlordReport';
import bizLandlordReportDetail from './modules/bussiness/financialReport/landlordReportDetail';
import bizLandlordReportHistory from './modules/bussiness/financialReport/landlordReportHistory';
import bizNewLandlordReport from './modules/bussiness/financialReport/newLandlordReport';
import bizReportOverView from './modules/bussiness/financialReport/reportOverView';
// 業務分群
import bizOrganizationGroupList from './modules/bussiness/internalAuth/organizationGroup/organizationGroup';
// 企業員工
import bizEmployeeRoleList from './modules/bussiness/internalAuth/employeeRole/employeeRole';
// 帳號管理
import bizAccountMgt from './modules/bussiness/internalAuth/accountMgt/accountMgt';
//設置中心
// 飛豬錢包
import bizBillChargeMode from './modules/bussiness/settingCenter/billChargeMode/billChargeMode';
// 飛豬錢包
import bizWallet from './modules/bussiness/settingCenter/wallet/wallet';
// 電子發票
import bizEinvoice from './modules/bussiness/settingCenter/einvoice/einvoice';

// landingPage
// 企業首頁
import enterpriseIntro from './modules/landingPage/enterpriseIntro';

Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
        // 全域
        modalStatus,
        alarmStatus,
        globalList,
        accountType,
        log,
        // mb
        mbEnterpriseGlobal,
        mbEnterpriseAlarmStatus,
        mbEnterpriseMeterRecord,
        // 個人房東
        user,
        houseStatus,
        recommandTenant,
        bookingManagement,
        houseManagement,
        leaseManagement,
        evaluation,
        addHouse,
        editHouse,
        newContract,
        loadingAnimation,
        device,
        batchUpload,
        memberCenter,
        userVerified,
        financialManagement,
        financialAccountingBook,
        financialBill,
        leaseDone,
        shareHouse,
        userWallet,
        //企業
        bizUser,
        bizPersonalCenter,
        bizTodoListGraph,
        bizTodoList,
        bizRecommandTenant,
        bizHouseManagement,//todo
        bizHouseGroupManagement,
        bizEditHouseGroup,
        bizBatchPolicy,
        bizBatchPublish,
        bizBatchDispatch,
        bizBatchContractVersion,
        bizAddHouse,
        bizEditHouse,
        bizBatchUpload,
        bizBookingMgt,
        bizTaskDoneMgt,
        bizTaskUnpaidMgt,
        bizTaskProcessMgt,
        bizLeaseMgtProcess,
        bizLeaseMgtBeSigned,
        bizLeaseMgtFinished,
        bizRenewalContract,
        bizMeterRecord,
        bizlandlordMgt,
        bizBatchNotify,
        bizBatchMeterNotify,
        bizBatchBill,
        bizNewContract,
        bizNewEContract,
        bizSignContract,
        bizBillManagement,
        bizLedgerManagement,
        bizLandlordReport,
        bizLandlordReportDetail,
        bizLandlordReportHistory,
        bizNewLandlordReport,
        bizReportOverView,
        bizOrganizationGroupList,
        bizEmployeeRoleList,
        bizAccountMgt,
        bizBillChargeMode,
        bizWallet,
        bizEinvoice,
        // landingPage
        enterpriseIntro
    }

})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js